import type { Gender } from 'models';
import { useQuery } from 'query';
import { getGenders } from '../services';
import { getGendersQueryKey } from './keys';

export const useGenders = () =>
  useQuery<Gender[]>({
    async queryFn() {
      const { data } = await getGenders();
      return data;
    },
    queryKey: getGendersQueryKey(),
  });
